import { tv } from 'tailwind-variants';

const styles = tv({
  base: `
      flex
      h-12
      items-center
      px-3
      [&:nth-child(odd)]:bg-gray-100
    `,
});

export default styles;
